import el from '@finn-no/create-element';

function generateBroadcastHtml(heading, message, index) {
    // Done this way to allow html (links in particular), in the message
    const innerMessage = document.createElement('p');
    innerMessage.innerHTML = message;

    return el(
        'div.mod.green-skin',
        null,
        el(
            'div.inner',
            null,
            el(
                'div.bd',
                {
                    role: 'region',
                    'aria-label': `Viktig melding${index
                        ? ` ${index + 1}`
                        : ''}`,
                },
                heading ? el('h2.t3', null, heading) : null,
                innerMessage
            )
        )
    );
}

function broadcast(
    {
        ele = document.getElementById('broadcast'),
        broadcastUrl = 'https://www.finn.no/broadcasts',
    } = {}
) {
    const url = new URL(broadcastUrl);

    url.searchParams.set('path', window.location.href);

    return window
        .fetch(url.href, { credentials: 'include' }) // Needs credentials to avoid new USERID
        .then(response => {
            if (response.ok) {
                return response.json();
            }

            return Promise.reject(response);
        })
        .then(broadcastMessages => {
            broadcastMessages
                .filter(broadcastMessage => broadcastMessage.message)
                .map((broadcastMessage, index) =>
                    generateBroadcastHtml(
                        broadcastMessage.heading,
                        broadcastMessage.message,
                        index
                    )
                )
                .forEach(broadcastMessage => {
                    ele.appendChild(broadcastMessage);
                });
        });
}

module.exports = broadcast;
